import { render, staticRenderFns } from "./ConsultantPayments.vue?vue&type=template&id=5610db1b&"
import script from "./ConsultantPayments.vue?vue&type=script&lang=js&"
export * from "./ConsultantPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports